import { Box } from "@mui/material";
import PageHeader from "../../components/PageHeader";
import HeaderPhoto from "../../assets/images/bees/andrena_helianthiformis2.jpg";
import Overview from "./Overview";
import Habitats from "./Habitats";
import BeeGallery from "./BeeGallery";
import BeeKeys from "./BeeKeys";

const BeeProject = () => {
  return (
    <Box>
      <PageHeader
        image={HeaderPhoto}
        title="The Bees of the Southern Lake Michigan Region Project"
      />

      <Overview />
      <Habitats />
      <BeeKeys />
      <BeeGallery />
    </Box>
  );
};

export default BeeProject;
